import React, { useCallback } from 'react';
import LockIcon from '@mui/icons-material/Lock';

const LockIconCustom = ({ color = '#eac210' }) => (
    <LockIcon
        fontSize="small"
        sx={{
            position: 'absolute',
            top: 4,
            right: 4,
            fontSize: '14px',
            color: color,
            opacity: 0.9,
        }}
    />
);

const ChessBoardSelectCell = ({
    typeCabinet,
    onSelect,
    dataCell = [],
    selectedCell = null,
    cell_id_request = null,
    device_cd = null,
    just_device_cd = false,
    qty = -1,
}) => {
    const getCellKey = (row, col) => `${row}-${col}`;
    const isCellDisabled = (cell) => {
        if (just_device_cd) {
            return !(cell.device_cd === device_cd && cell.qty >= qty && cell.block_status === '1');
        }
        if (device_cd) {
            return (
                (cell.device_id !== null || cell.block_status !== '1') &&
                cell.id !== cell_id_request &&
                cell.device_cd !== device_cd &&
                device_cd !== null
            );
        }
        return (cell.device_id !== null || cell.block_status !== '1') && cell.id !== cell_id_request;
    };
    const isCellSelected = (cell) => {
        return (
            selectedCell &&
            selectedCell.cell_lc?.row === cell.cell_lc?.row &&
            selectedCell.cell_lc?.column === cell.cell_lc?.column
        );
    };

    const handleSelect = (cell) => {
        if (onSelect && !isCellDisabled(cell)) {
            onSelect(cell);
        }
    };

    const generateGridSquare = () => {
        // Tạo map key duy nhất "row-column" để lọc trùng
        const uniqueMap = new Map();

        dataCell.forEach((cell) => {
            const row = cell.cell_lc?.row;
            const col = cell.cell_lc?.column;
            const key = `${row}-${col}`;
            if (!uniqueMap.has(key)) {
                uniqueMap.set(key, cell);
            }
        });

        const uniqueCells = Array.from(uniqueMap.values());

        // Nhóm lại theo row
        const grouped = uniqueCells.reduce((acc, cell) => {
            const row = cell.cell_lc?.row;
            if (!acc[row]) acc[row] = [];
            acc[row].push(cell);
            return acc;
        }, {});

        const sortedRows = Object.keys(grouped)
            .map(Number)
            .sort((a, b) => b - a)
            .map((row) => {
                const columns = grouped[row].sort((a, b) => a.cell_lc.column - b.cell_lc.column);
                return (
                    <div key={`row-${row}`} className="grid-row">
                        {columns.map((cell) => {
                            const row = cell.cell_lc?.row;
                            const col = cell.cell_lc?.column;
                            const key = `${row}-${col}`;
                            const disabled = isCellDisabled(cell);
                            const selected = isCellSelected(cell);

                            return (
                                <div
                                    key={key}
                                    className={`grid-cell ${selected ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
                                    onClick={() => handleSelect(cell)}
                                    style={{ cursor: disabled ? 'not-allowed' : 'pointer', position: 'relative' }}
                                >
                                    {`${row}-${col}`}
                                    {just_device_cd &&
                                    cell?.qty < qty &&
                                    device_cd === cell?.device_cd &&
                                    cell.block_status !== '1' ? (
                                        <LockIconCustom color="#d66305" />
                                    ) : (
                                        disabled && !selected && <LockIconCustom />
                                    )}
                                </div>
                            );
                        })}
                    </div>
                );
            });

        return sortedRows;
    };

    const generateGridRound = () => {
        const uniqueMap = new Map();

        dataCell.forEach((cell) => {
            const row = cell.cell_lc?.row;
            const col = cell.cell_lc?.column;
            const key = `${row}-${col}`;
            if (!uniqueMap.has(key)) {
                uniqueMap.set(key, cell);
            }
        });

        const uniqueCells = Array.from(uniqueMap.values());
        const sorted = [...uniqueCells].sort((a, b) => {
            if (a.cell_lc?.row === b.cell_lc?.row) {
                return a.cell_lc?.column - b.cell_lc?.column;
            }
            return b.cell_lc?.row - a.cell_lc?.row;
        });

        const rows = [];
        let tempRow = [];

        sorted.forEach((cell, index) => {
            const row = cell.cell_lc?.row;
            const col = cell.cell_lc?.column;
            const key = getCellKey(row, col);
            const disabled = isCellDisabled(cell);
            const selected = isCellSelected(cell);

            tempRow.push(
                <div
                    key={key}
                    className={`grid-cell ${selected ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
                    onClick={() => handleSelect(cell)}
                    style={{ cursor: disabled ? 'not-allowed' : 'pointer', position: 'relative' }}
                >
                    {`${col}`}
                    {just_device_cd && cell?.qty < qty && device_cd === cell?.device_cd ? (
                        <LockIconCustom color="#d66305" />
                    ) : (
                        disabled && !selected && <LockIconCustom />
                    )}
                </div>
            );

            if ((index + 1) % 5 === 0 || index === sorted.length - 1) {
                rows.push(
                    <div key={`round-row-${index}`} className="grid-row">
                        {tempRow}
                    </div>
                );
                tempRow = [];
            }
        });

        return rows;
    };

    return (
        <div className="grid-container">
            <div className="grid">{typeCabinet === 'round' ? generateGridRound() : generateGridSquare()}</div>
        </div>
    );
};

export default ChessBoardSelectCell;
